import { CenteredLoading, mt } from '@openeducation/oe-it-components';
import { teacherProfileAtom } from '@openeducation/oe-it-jotai-atoms';
import { getUrlParams } from '@openeducation/oe-it-services';
import { ClassroomPage, openClassroomLinks } from '@openeducation/oe-it-teacher-portal';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-native';

import { useClassroomErrorMessage } from './use-classroom-error-message';

// This screen is used to open the classrooom for the monitor, when he opens from onEnterMonitorPress
export const ClassroomScreen = () => {
  const navigate = useNavigate();
  const { studentId, classroomId, teacherId, classroomUrl, learningMaterialUrl, classType } =
    getUrlParams();

  const teacherProfile = useAtomValue(teacherProfileAtom);

  const { message } = useClassroomErrorMessage({ classroomId, classroomUrl, classType });

  useEffect(() => {
    if (!teacherProfile) return;

    openClassroomLinks({
      classType,
      learningMaterialUrl,
      classroomUrl,
      teacherId,
      studentId,
      classroomId,
    });
  }, [
    classType,
    classroomId,
    classroomUrl,
    learningMaterialUrl,
    navigate,
    studentId,
    teacherId,
    teacherProfile,
  ]);

  if (!teacherProfile) {
    return <CenteredLoading size={100} style={mt(100)} />;
  }

  return <ClassroomPage message={message} />;
};
